export const  FETCH_SUGGESTIONS = 'FETCH_SUGGESTIONS';
export const  CLEAR_SUGGESTIONS = 'CLEAR_SUGGESTIONS';
export const  SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const  LOGOUT_USER = 'LOGOUT_USER';